import { render, staticRenderFns } from "./html/ItemCustomizations.html?vue&type=template&id=52423060&lang=html&external"
import script from "./js/ItemCustomizations.js?vue&type=script&lang=js&external"
export * from "./js/ItemCustomizations.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports